import type { SVGProps } from "react";

/**
 * Shield + exclamation for submission-blocked / validation modals.
 * Color via parent `className` (e.g. `text-requiredRed`).
 */
function SubmissionBlockedValidationIcon(props: Readonly<SVGProps<SVGSVGElement>>): JSX.Element {
  const { className, width = 40, height = 40, ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      width={width}
      height={height}
      className={className}
      fill="none"
      aria-hidden
      {...rest}
    >
      <path
        d="M20 3.5 33 9.75V20.25c0 6.5-4.75 12.5-11.25 15.25a1.25 1.25 0 0 1-1.5 0C13.75 32.75 9 26.75 9 20.25V9.75L20 3.5Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <path
        d="M20 13.5v8.25"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <circle cx="20" cy="26.75" r="1.25" fill="currentColor" />
    </svg>
  );
}

export default SubmissionBlockedValidationIcon;
